import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { analytics, logEvent } from "../firebase";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Brandon Hightower</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} BH</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/bkh5433"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => logEvent(analytics, 'social_click', { platform: 'github', location: 'footer' })}
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/brandonahightower/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => logEvent(analytics, 'social_click', { platform: 'linkedin', location: 'footer' })}
              >
                <FaLinkedinIn />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
